import Slider from "infinite-react-carousel";
import NotableFollowersMobile from "../NotableFollowersMobile";
import "./index.css";

function NotableFollowerCorouselMobile(props) {
  const settings = {
    centerPadding: 40,
    duration: 100,
    initialSlide: true,
    shift: 20,
    slidesToShow: 2,
  };
  return (
    <div style={{ width: "98vw" }} className="notablefollowerslider">
      <Slider {...settings}>
        {props?.data?.map((item, index) => {
          return (
            <div className="notablecorouselsecscon">
              <NotableFollowersMobile
                NotableFollowerName={item?.NotableFollowerName}
                NotableFollowerTwitter={item?.NotableFollowerTwitter}
                NotableFollowersImg={item?.NotableFollowersImg}
              />
            </div>
          );
        })}
      </Slider>
    </div>
  );
}
export default NotableFollowerCorouselMobile;
